export default "__VITE_ASSET__CkYWYZoH__"